import styled from 'styled-components';
import { colour, Heading1, Heading2, Heading3, Heading4, media, spacing } from '../../../../theme';

export const ItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const LineItemContainer = styled.div`
    display: flex;
`;

export const OrderGroupContainer = styled.div`
    border-bottom: 1px solid ${colour.palette.greyscale5};
    padding-bottom: ${spacing.spacing5};
`;

export const FineDetails = styled.div`
    display: flex;
    justify-content: space-between;
    margin: ${spacing.spacing3} ${spacing.spacing2} ${spacing.spacing3} ${spacing.spacing3};
`;

export const OrderSummaryText = styled.p`
    font-size: inherit;
    line-height: 1.6;
    text-rendering: optimizeLegibility;
    margin: ${spacing.spacing2} ${spacing.spacing0} ${spacing.spacing2} ${spacing.spacing0};

    & + ul {
        margin-top: -${spacing.spacing3};
    }

    & + ${Heading1}, & + ${Heading2}, & + ${Heading3}, & + ${Heading4} {
        margin-top: ${spacing.spacing6};
    }
`;
